const keywords = [
	'Solar Energy',
	'Solar Incentives',
	'Maryland Solar Grants',
	'Renewable Energy Credits (SRECs)',
	'Net Metering',
	'Solar Gabe',
	'Solar Tax Credits',
	'Energy Independence',
	'Photovoltaic System (PV)',
	'Solar Financing',
	'Solar ROI',
	'Interconnection',
	'Residential Solar',
	'Commercial Solar',
	'Off-grid Solar',
	'Maryland Energy Administration (MEA)',
	'Solar Rebates',
	'Utility Savings',
	'Grid-tied Systems',
	'Battery Backup',
	'Quality Installation',
	'Sustainable Energy',
	'Energy Storage',
	'Solar Panel Efficiency',
	'Local Installers',
	'Utility Bill Savings',
	'Solar Consultants',
	'Energy Assessment',
	'Solar Warranties',
	'Panel Lifespan',
	'Environmental Impact',
	'kWh Production',
	'Federal Investment Tax Credit (ITC)',
	'Tier 1 Panels',
	'System Monitoring',
	'Site Survey',
	'Solar Design',
	'Permitting',
	'Energy Resilience',
	'Installation Timeline',
	'Project Management',
	'Solar Panel Brands',
	'Clean Energy',
	'Cost-benefit Analysis',
	'On-site Consultation',
	'Weather Resilience',
	'Solar Efficiency',
	'Clean Energy',
	'Sustainable Living',
	'Energy Efficiency',
	'Solar Power Purchase Agreement (PPA)',
	'Leasing Options',
	'Inverter Technology',
	'Microinverters',
	'String Inverters',
	'Power Optimizers',
	'Module-level Monitoring',
	'Feed-in Tariff',
	'Energy Payback Time',
	'kWh Savings',
	'Annual Energy Consumption',
	'System Sizing',
	'Electrical Panel Upgrade',
	'Fixed Tilt',
	'Solar Trackers',
	'ROI',
	'Maintenance Plan',
	'Local Incentives',
	'Shading Analysis',
	'Solar Potential',
	'Degradation Rate',
	'Renewable Portfolio Standard (RPS)',
	'Performance-based Incentives',
	'Installation Timeline',
	'Community Solar',
	'Ground-Mounted Systems',
	'Roof-Mounted Systems',
	'Solar Loans',
	'Carbon Footprint Reduction',
	'Panel Orientation',
	'Panel Tilt',
	'Solar Installation Codes',
	'Certified Installers',
	'Due Diligence',
	'Service Contracts',
	'O&M Services (Operations and Maintenance)',
	'Solar Inspection',
	'AC/DC Coupling',
	'Panel Efficiency',
	'Cost per Watt',
	'Energy Production Estimate',
	'Subsidized Rates',
	'Solar Co-op',
	'Load Analysis',
	'Off-peak Production',
	'Peak Shaving',
	'Solar Canopy',
	'DIY Solar',
	'Best Practices',
	'Panel Manufacturer',
	'Grid Parity',
	'Energy Independence',
	'Clean Energy Jobs',
	'REC Alpha Series',
	'REC TwinPeak',
	'REC N-Peak',
	'Mono-crystalline Panels',
	'REC Panel Efficiency',
	'REC Warranty',
	'Split Cell Technology',
	'Backsheet',
	'High-Performance Panels',
	'Low-Light Performance',
	'Enphase IQ Series',
	'Enphase Energy',
	'IQ8+',
	'Enphase Envoy',
	'Enphase Enlighten',
	'Module-level Monitoring',
	'AC Coupling',
	'Panel Compatibility',
	'Enphase Reliability',
	'SolarEdge Inverter',
	'SolarEdge Optimizer',
	'SolarEdge Monitoring',
	'StorEdge',
	'SolarEdge P300',
	'SolarEdge P400',
	'Fixed Voltage Inverter',
	'DC-DC Optimizers',
	'SolarEdge Warranty',
	'Single-Phase Inverters',
	'SMA Sunny Boy',
	'SMA Tripower',
	'SMA Core1',
	'SMA Inverter Manager',
	'Secure Power Supply',
	'SMA Webconnect',
	'Sunny Portal',
	'Off-Grid Capabilities',
	'SMA Warranty',
	'SMA Grid Guard',
	'AC Voltage',
	'AC Circuit',
	'AC Frequency',
	'AC Waveform',
	'AC Distribution',
	'AC Coupling',
	'AC Disconnect',
	'AC Grid',
	'AC Phase',
	'DC Voltage',
	'DC Circuit',
	'DC Isolator',
	'DC Disconnect',
	'DC Efficiency',
	'DC Cables',
	'DC-DC Converter',
	'DC Fuses',
	'DC Bus',
	'Excess Generation',
	'Buyback Rate',
	'Monthly Settlement',
	'Annual True-Up',
	'Utility Grid',
	'Meter Rollback',
	'kWh Credits',
	'Net Metering Cap',
	'Grid-tied Systems',
	'Billing Cycle',
	'Solar Power',
	'Clean Energy Transition',
	'Solar Thermal',
	'Green Energy',
	'Zero Emissions',
	'Alternative Energy',
	'On-grid',
	'Off-grid',
	'Solar Controller',
	'Power Generation',
	'Solar Hot Water',
	'Racking System',
	'Clamps and Brackets',
	'Polycrystalline',
	'Bifacial Panels',
	'Solar Carport',
	'Solar Pool Heating',
	'Thin-Film Solar',
	'Energy Density',
	'Peak Sun Hours',
	'Daily Energy Usage',
	'Nominal Power',
	'Efficiency Rating',
	'Grid Resilience',
	'Export Limit',
	'Solar Co-op',
	'Energy Management System',
	'Soft Costs',
	'Grid Modernization',
	'Solar-plus-Storage',
	'Islanding',
	'Payback Period',
	'Energy Reliability',
	'Power Factor',
	'Energy Security',
	'Revenue Grade Meter',
	'Environmental Benefits',
	'Local Jobs',
	'Fixed Costs',
	'Variable Costs',
	'Sun Path',
	'Solar Noon',
	'Orientation Angle',
	'Azimuth',
	'Elevation Angle',
	'Irradiance',
	'Energy Yield',
	'Hybrid Systems',
	'Blackout Protection',
	'Solar Software',
	'Cycles Per Second (Hertz)',
	'Surge Protection',
	'Clean Energy Standard (CES)',
	'Solar Future',
	'Solar Cell',
	'Photovoltaic Effect',
	'Polysilicon',
	'Greenhouse Gas (GHG) Reduction',
	'Time-of-Use Rates',
	'Feed-in Premium',
	'Solar Roadways',
	'Home Energy Management System (HEMS)',
	'Smart Meter',
	'Energy Resilience',
	'Remote Monitoring',
	'Electric Vehicle (EV) Charging',
	'Grid Integration',
	'Maryland Energy Administration (MEA)',
	'Baltimore Solar Initiative',
	'Maryland PSC (Public Service Commission)',
	'Maryland Solar RPS (Renewable Portfolio Standards)',
	'Local Incentives',
	'Maryland Interconnection Standards',
	'Maryland Solar Permitting',
	'Community Solar Projects',
	'Baltimore City Solar Zoning',
	'Utility Companies in Maryland',
	'Local Maryland Solar Installers',
	'Baltimore Solar Co-op',
	'SREC Trading',
	'SREC Market Price',
	'SREC Aggregators',
	'SREC Auction',
	'Maryland SREC Program',
	'Energy Credit Certificates',
	'Renewable Quotas',
	'SREC Expiry',
	'Bi-directional Meter',
	'Net-Metering Policy in Maryland',
	'Excess Energy Credits',
	'Grid Supply',
	'Peak Demand',
	'Off-Peak Hours',
	'Time-of-Use Net-Metering',
	'Utility Bill Reduction',
	'Grid Connection Fees',
	'Roll-Over Credits',
	'REC Alpha Pure',
	'REC TwinPeak 3',
	'REC Panel Durability',
	'REC Certification',
	'REC Solar Professionals',
	'REC Split Cells',
	'Temperature Coefficient',
	'REC Energy Yield',
	'Performance Ratio',
	'REC Sustainability',
	'Q.ANTUM Technology',
	'Q-Cells Mono Panels',
	'Q.PEAK DUO',
	'Q-Cells Warranty',
	'Q-Cells Performance',
	'Solar Cell Efficiency',
	'Anti-PID Technology',
	'Hot-Spot Protect',
	'Q-Cells Frame Design',
	'Q-Cells Certification',
	'Tesla Solar Roof',
	'Tesla Solar Glass',
	'Tesla V3 Solar Roof',
	'Tesla Solar Subscription',
	'Tesla Solar App',
	'Tesla Electric Cars',
	'Tesla Model S',
	'Tesla Model 3',
	'Tesla Model X',
	'Tesla Model Y',
	'EV Charging Stations',
	'Solar-Powered EV Charging',
	'Level 2 Charger',
	'EV Rebates in Maryland',
	'EV Battery Life',
	'Fast Charging',
	'EV Range',
	'EV Maintenance',
	'Electric Vehicle Infrastructure',
	'EV Tax Incentives',
	'Tesla Powerwall 2',
	'Battery Storage Capacity',
	'Depth of Discharge',
	'Powerwall Installation',
	'Grid-Independent',
	'Emergency Backup',
	'Load Shifting',
	'Time-Based Control',
	'Peak Shaving',
	'Battery Cycle Life',
	'Standby Generators',
	'Diesel Generator',
	'Gasoline Generator',
	'Generator Sizing',
	'Generator Load',
	'Fuel Storage',
	'Portable Generator',
	'Generator Maintenance',
	'Automatic Transfer Switch',
	'Generator Efficiency',
	'Enphase IQ7X',
	'Micro-Inverter Benefits',
	'Enphase MyEnlighten',
	'Enphase Installer Network',
	'Enphase Compatibility',
	'Burst Mode',
	'Power Output',
	'Enphase Safety Features',
	'Enphase Scalability',
	'Quick Installation',
	'AC Wiring',
	'AC Voltage Regulation',
	'AC Frequency Control',
	'AC Power Factor',
	'AC Quality',
	'AC Harmonics',
	'AC Surge Protection',
	'AC Switchgear',
	'AC Power Lines',
	'AC Transformers',
	'Wind Power',
	'Hydropower',
	'Geothermal Energy',
	'Biomass Energy',
	'Renewable Portfolio Standards',
	'Clean Energy Standard',
	'Sustainable Energy',
	'Carbon Offset',
	'Renewable Certificates',
	'Offshore Wind Farms',
	'Photovoltaic (PV) Cells',
	'Solar Array',
	'Solar Irradiance',
	'Solar Insolation',
	'Grid-tied System',
	'Solar Tracking',
	'Crystalline Silicon',
	'Solar Farm',
	'Floating Solar',
	'Distributed Generation',
	'Mounting Brackets',
	'Racking Systems',
	'Solar Clamps',
	'Junction Box',
	'String Combiner',
	'DC Isolator Switch',
	'AC Disconnect',
	'Conduit',
	'Charge Controller',
	'Grounding Equipment',
	'Safety Harness',
	'Roof Anchors',
	'PV Wire',
	'Panel Connectors (MC4)',
	'Cable Management Clips',
	'Central Inverter',
	'String Inverter',
	'Microinverter',
	'SolarEdge Inverters',
	'SMA Inverters',
	'Enphase Microinverters',
	'Off-Grid Inverter',
	'Hybrid Inverter',
	'Battery-Based Inverter',
	'Grid-Tie Inverter',
	'Tesla Powerwall',
	'LG Chem RESU',
	'Deep-Cycle Batteries',
	'Gel Batteries',
	'Lead-Acid Batteries',
	'Lithium-Ion Batteries',
	'Battery Management System',
	'Battery Enclosure',
	'Peak Shaving',
	'Time-of-Use Storage',
	'Energy Arbitrage',
	'Enphase Encharge',
	'Ensemble Technology',
	'AC-Coupled',
	'Modular Design',
	'Grid-Agnostic',
	'Lithium Iron Phosphate (LiFePO4)',
	'Backup Power',
	'Energy Storage',
	'Scalable Solution',
	'Smart Battery',
	'Enphase Enlighten',
	'Off-Grid Capability',
	'Two-Way Inverter',
	'Solar Integration',
	'Time-of-Use',
	'Peak Shaving',
	'Energy Management',
	'kWh Capacity',
	'Self-Consumption',
	'Solar-Plus-Storage',
	'Essential Loads',
	'Charge/Discharge Efficiency',
	'Energy Arbitrage',
	'Nissan Leaf',
	'Chevrolet',
	'Chevrolet Bolt EV',
	'Chevrolet Bolt EUV',
	'Audi e-tron',
	'Audi Q4 e-tron',
	'Audi RS e-tron GT',
	'BMW i3',
	'BMW i4',
	'BMW i8 (Plug-in Hybrid)',
	'BMW iX',
	'BMW iX3',
	'Volkswagen ID.4',
	'Hyundai Kona Electric',
	'Hyundai Ioniq Electric',
	'Hyundai Ioniq 5',
	'Kia Soul EV',
	'Kia Niro EV',
	'Porsche Taycan',
	'Ford Mustang Mach-E',
	'Ford F-150 Lightning (Announced)',
	'Mercedes-Benz',
	'Mercedes-Benz EQC',
	'Mercedes-Benz EQS',
	'Volvo XC40 Recharge',
	'Volvo C40 Recharge',
	'Lucid',
	'Lucid Air',
	'Rivian',
	'Rivian R1T',
	'Rivian R1S',
	'green washing',
	'climate emergency',
	'eco friendly',
	'ethical',
	'sustainable',
	'pescetarian',
	'regenerative',
	'fluff fuel',
];
const companyName = 'Solar Gabe';
let seo = {
	companyName,
	company: {
		name: companyName,
		phone: '443-469-0030',
		email: 'gabe@solargabe.com',
		address: {
			street: '',
			city: 'Baltimore',
			state: 'MD',
			zip: '',
			country: 'USA',
		},
	},
	site: {
		title: `${companyName} | Solar Energy Consultant in Baltimore, MD`,
		description: `Personal, transparent solar guidance for Maryland homeowners. From your first quote to final inspection, ${companyName} makes going solar simple.`,
		url: 'https://www.solar-gabe.com/',
		keywords: keywords
			.map((keyword) => {
				return keyword.trim();
			})
			.join(', '),
		viewport: 'width=device-width, initial-scale=1.0',
	},
	location_language: {
		region: 'US-East',
		language: 'en-US',
		placename: 'Baltimore',
		position: '33.4484° N, 112.0740° W',
	},
	img: {
		favicon: 'https://www.solar-gabe.com/favicon.ico',
		twitter: 'https://www.solar-gabe.com/logos/VCS Logo White.jpg',
	},
	social: {
		facebook: {
			username: '@solargabe',
			url: 'https://www.facebook.com/solargabeofficial',
		},
		instagram: {
			username: '@solargabeofficial',
			url: 'https://www.instagram.com/solargabeofficial',
		},
		linkedin: {
			username: '@solargabe',
			url: 'https://www.linkedin.com/in/gabriel-shabtai-875134199/',
		},
	},
	nav: [],

	dev: {
		twitter: {
			username: '@andrewkeiser_',
			url: 'https://twitter.com/andrewkeiser_',
		},
	},
};

seo = {
	...seo,
	social: {
		...seo.social,
		nav: [
			{
				name: 'Facebook',
				href: '#',
				icon: (props) => (
					<svg
						fill='currentColor'
						viewBox='0 0 24 24'
						{...props}
					>
						<path
							fillRule='evenodd'
							d='M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z'
							clipRule='evenodd'
						/>
					</svg>
				),
			},
			{
				name: 'Instagram',
				href: seo.social.instagram.url,
				icon: (props) => (
					<svg
						fill='currentColor'
						viewBox='0 0 24 24'
						{...props}
					>
						<path
							fillRule='evenodd'
							d='M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z'
							clipRule='evenodd'
						/>
					</svg>
				),
			},
			// {
			// 	name: 'Twitter',
			// 	href: seo.social.twitter.url,
			// 	icon: (props) => (
			// 		<svg
			// 			fill='currentColor'
			// 			viewBox='0 0 24 24'
			// 			{...props}
			// 		>
			// 			<path d='M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84' />
			// 		</svg>
			// 	),
			// },
			// {
			// 	name: 'GitHub',
			// 	href: '#',
			// 	icon: (props) => (
			// 		<svg
			// 			fill='currentColor'
			// 			viewBox='0 0 24 24'
			// 			{...props}
			// 		>
			// 			<path
			// 				fillRule='evenodd'
			// 				d='M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z'
			// 				clipRule='evenodd'
			// 			/>
			// 		</svg>
			// 	),
			// },
			// {
			// 	name: 'YouTube',
			// 	href: '#',
			// 	icon: (props) => (
			// 		<svg
			// 			fill='currentColor'
			// 			viewBox='0 0 24 24'
			// 			{...props}
			// 		>
			// 			<path
			// 				fillRule='evenodd'
			// 				d='M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.417-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z'
			// 				clipRule='evenodd'
			// 			/>
			// 		</svg>
			// 	),
			// },
		],
	},
};

export default seo;
